import React from 'react';
import { CharterSection, H3Text, ImageOverlay } from './FAQ.style';

import styled from 'styled-components';

const FAQOverlay = styled(ImageOverlay)`
  text-align: left;
  min-height: 200px;
`;

const FAQList = styled.ul`
  padding: 12px;

  & > li {
    margin: 32px 0;
  }
`;

const FAQ = ({ HeadTitle, HeadDesc, QuestionLists }) => {
  return (
    <CharterSection>
      <FAQOverlay $img="imgs/webp/charterQuote/business-jet-closeup.webp">
        <h2>{HeadTitle}</h2>
        <p>{HeadDesc}</p>
      </FAQOverlay>
      <FAQList>
        {QuestionLists.map((item, index) => (
          <li key={index}>
            <H3Text>{item.question}</H3Text>
            {item.answer}
          </li>
        ))}
      </FAQList>
    </CharterSection>
  );
};

export default FAQ;
